<template>
  <div>
    <form class="needs-validation" @submit.prevent="submitEditPayer">

      <div class="form-group">
        <label for="inn">ИНН</label>
        <input
            id="inn"
            v-model="payerData.inn"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.payerData.inn.$error }"
        />
      </div>

      <div class="form-group">
        <label for="legal_address">Юр. адрес организации</label>
        <input
            id="legal_address"
            v-model="payerData.legal_address"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.payerData.inn.$error }"
        />
      </div>

      <div class="form-group">
        <label for="name">Наименование организации</label>
        <input
            id="name"
            v-model="payerData.name"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.payerData.inn.$error }"
        />
      </div>

      <div class="form-group">
        <label for="current_account">Расчетный счет</label>
        <input
            id="current_account"
            v-model="payerData.current_account"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.payerData.inn.$error }"
        />
      </div>

      <div class="form-group">
        <label for="bank_bic">БИК банка</label>
        <input
            id="bank_bic"
            v-model="payerData.bank_bic"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.payerData.inn.$error }"
        />
      </div>

      <div class="form-group">
        <label for="bank_name">Наименование банка</label>
        <input
            id="bank_name"
            v-model="payerData.bank_name"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.payerData.inn.$error }"
        />
      </div>

      <div class="form-group">
        <label for="bank_name">Город банка</label>
        <input
            id="bank_city"
            v-model="payerData.bank_city"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.payerData.inn.$error }"
        />
      </div>

      <div class="form-group">
        <label for="bank_address">Юр. адрес банка</label>
        <input
            id="bank_address"
            v-model="payerData.bank_address"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.payerData.inn.$error }"
        />
      </div>

      <div class="form-group">
        <label for="corr_account">Корсчет</label>
        <input
            id="corr_account"
            v-model="payerData.corr_account"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.payerData.inn.$error }"
        />
      </div>

    </form>
  </div>

</template>

<script>
import axios from "axios";

export default {
  name: "EditPayer",
  data() {
    return {
      payerData: {
        inn: null,
        name: null,
        legal_address: null,
        current_account: null,
        bank_bic: null,
        bank_name: null,
        bank_city: null,
        bank_address: null,
        corr_account: null,
      },
      submitted: false,
    }
  },
  methods: {
    setNullFormData() {
      this.payerData = {
        inn: null,
        name: null,
        legal_address: null,
        current_account: null,
        bank_bic: null,
        bank_name: null,
        bank_city: null,
        bank_address: null,
        corr_account: null,
      }
    },
    getPayerData() {
      axios
          .get(`/v1/payment-payers/get-default`)
          .then(resp => {
            this.payerData = resp.data;
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    },
    setPayerData() {
      let formData = new FormData();

      for(let key in this.payerData){
        if (this.payerData[key] === null) {
          continue;
        }
        if( typeof this.payerData[key] === 'object'){
          formData.append(key, JSON.stringify(this.payerData[key]));
        }else{
          formData.append(key, this.payerData[key]);
        }
      }

      axios
          .post(`/v1/payment-payers/set-default`, formData)
          .then(resp => {
                alert('Плательщик отредактирован');
              }
          )
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;

    },
  },
}
</script>

<style scoped lang="scss">

</style>